import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Footer from './components/Footer'

import Layout from "./components/layout"
import Navbar from './components/Navbar';
// // Components
import Header from "./components/Header"
import Work from "./components/Work"
import Artwork from "./components/Artwork"
import Fiddle from "./components/fiddle"

import ScrollButton from "./components/ScrollButton"
import GmicChaos from './components/GmicChaos';
import Sammelkarten from './components/sammelkarten';
import GelberSack from './components/p5_Gallery';

import VideoBg from "reactjs-videobg";
import gif from "./images/bg.gif";
import GitInfo from 'react-git-info/macro';

// import poster from "./images/bitcrush.PNG";
// import sNotFound from "./components/404"


// export function disableBG() {
//   alert('Hallo');
//   gif = null;
//   this.forceUpdate();
// }


gif=null;

export default function App() {
  return (

    <BrowserRouter>
      <Routes>

        <Route path='/'
          element={
            <Fragment>
              <VideoBg poster={gif}>
                {/* <VideoBg.Source src={video} type="video/mp4" /> */}
                {/* <VideoBg.Source src={webm} type="video/webm" /> */}
              </VideoBg>
              <Layout></Layout>
              < Header />
              <Work></Work>
              <Artwork>
              </Artwork>
              <Footer></Footer>
              <ScrollButton></ScrollButton>

            </Fragment>

          }
        />
        <Route path='gmicchaos'
          element={
            <Fragment>
              <Layout></Layout>
              <GmicChaos></GmicChaos>
            </Fragment>
          }
        />
        <Route path='fiddle'
          element={
            <Fragment>
              <Layout></Layout>
              <Fiddle></Fiddle>
            </Fragment>
          }
        />
        <Route path='sammelkarten'
          element=
          {
            <Fragment>
              <Layout></Layout>
              <Sammelkarten>

              </Sammelkarten>
            </Fragment>
          }
        />

        <Route path='p5'
          element=
          {
            <Fragment>
              <Layout></Layout>
              <GelberSack></GelberSack>
              <ScrollButton></ScrollButton>

            </Fragment>
          }
        />

        <Route path="*" element={<sNotFound></sNotFound>} />
      </Routes>
    </BrowserRouter>
  );
}


const gitInfo = GitInfo();
console.log("Branch_Name 🚀:" + gitInfo.branch);
console.log("Commit_Time ⏰:" + gitInfo.commit.date);

ReactDOM.render(<App />, document.getElementById("root"));


// reportWebVitals();
